import styled from 'styled-components'
import { Calendar } from 'react-multi-date-picker'
import { COLORS } from 'theme'

export const StyledCalender = styled(Calendar)`
  margin-right: 2rem;
  box-shadow: 0 0 1px transparent !important;
  position: relative;
  top: -1rem;
  left: -1rem;
  .rmdp-day.rmdp-selected span:not(.highlight) {
    background-color: ${COLORS.PRIMARY} !important;
  }
  .rmdp-week-day {
    color: ${COLORS.PRIMARY} !important ;
  }
  .rmdp-today span{
    background-color : #fff !important; 
    color : black !important;
  }
  .rmdp-day.rmdp-today.rmdp-selected span {
    background-color: rgb(50, 73, 215) !important;
    color : #fff !important;
  }
  .rmdp-shadow {
    border-collapse: inherit !important;
  }
`
